export const Delivery = {
  Header: '配送状況のご確認',
  BlockTitle: {
    Status: '配送状況',
    Content: '配送内容',
  },
  Status: {
    Unshipped: '未発送',
    Shipped: '発送完了',
    Receipted: '受取完了',
  },
  ConfirmText: 'お薬を受け取りましたか？',
  Button: '受取完了',
};
